<template>
    <section class="checkout-section checkout-section-phone-nospace">
        <div class="section-row">
            <div class="section-header">
                <h2>{{ resources.titleLabel }}</h2>
            </div>

            <span class="section-row-header">
                {{ resources.numberOfProducts }}

                <a v-if="show" class="section-link" v-on:click="showHideProducts">{{ resources.showProductsLabel }}</a>
                <a v-else class="section-link" v-on:click="showHideProducts">{{ resources.hideProductsLabel }}</a>
            </span>

            <cart-line-items v-if="!show" :items="lineItems.cartLineItems" />
            <cart-line-items v-if="!show && lineItems.cartGiftWrapLineItems.length" :items="lineItems.cartGiftWrapLineItems" />
            <a class="section-link" v-if="!show" @click="editCart">{{ resources.editLabel }}</a>
        </div>

        <div :class="{'section-row': !show}">
            <div class="section-row-wrapper-mobile" v-if="lineItems.cartFreeBonusProducts.length && !show">
                <cart-line-items :items="lineItems.cartFreeBonusProducts" :isGift='false' />
            </div>

            <div class="section-row-wrapper-mobile" v-if="lineItems.cartGiftLineItems.length && !show">
                <span class="section-row-header">{{ resources.giftSubtitleLabel }}</span>
                <cart-line-items :items="lineItems.cartGiftLineItems" :isGift='true' />
            </div>

            <div class="section-row-wrapper-mobile" v-if="lineItems.cartDiscountItems.length && !show">
                <cart-line-items :items="lineItems.cartDiscountItems" :isRefill='true' :isGift='true' />
            </div>

            <div class="cost-details" v-if="!show">
                <div class="cost-detail-row">
                    <span>{{ resources.subtotalLabel }}</span>
                    <span>{{ orderSubtotal }}</span>
                </div>
                <div v-if="promotions">
                    <div v-for="promotion in promotions" :key="promotion.name">
                        <div class="cost-detail-row">
                            <span>{{ promotion.name}}</span>
                            <span>{{ promotion.discount }}</span>
                        </div>
                    </div>
                </div>
                <div class="cost-detail-row" v-if="giftCardDeductionAmountValue > 0">
                    <span>{{ resources.giftCardsLabel }}</span>
                    <span>{{ giftCardDeductionAmount }}</span>
                </div>
                <div class="cost-detail-row" v-if="giftWrapAndGreetCardPriceValue > 0">
                    <span>{{ resources.giftWrapAndGreetCardLabel }}</span>
                    <span>{{ giftWrapAndGreetCardPrice }}</span>
                </div>
                <div class="cost-detail-row">
                    <span>{{ resources.deliveryLabel }}</span>
                    <span>{{ shippingPrice }}</span>
                </div>
            </div>

            <div :class="['cost-details', {'products-hidden': show}]">
                <div class="cost-detail-row">
                    <span>
                        {{ resources.totalLabel }}
                        <span class="taxes-included">{{ resources.taxesLabel }}</span>
                    </span>
                    <span>{{ orderTotalsPrice }}</span>
                </div>
            </div>
            <div v-if="!show" class="btn--checkout">
                <send-checkout-link-button/>
            </div>
        </div>
    </section>
</template>

<script src='./order-overview.js'></script>
